module.exports = __webpack_public_path__ + "static/media/6-6.3a598b4a.mp3";